import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of, tap } from "rxjs";
import { ClientSettingsService } from "@shared/business/services/client-settings.service";
import { logger } from "@shared/base/utils/logger";

@Injectable({
    providedIn: "root",
})
export class KeyTreeTranslationServiceService {
    private readonly clientSettingsService = inject(ClientSettingsService);

    checkSchemaExists(key: string): Observable<string | null> {
        return this.clientSettingsService.getTranslations().pipe(
            map((json) => {
                if (json == null) {
                    logger?.debug("No traductions found");
                    return null;
                }
                const keys = key.split(".");
                let value = json;
                for (const k of keys) {
                    value = value[k];
                    if (value === undefined) {
                        logger?.warn(`Key ${key} not found in JSON`);
                        return null;
                    }
                }
                return value ? value : null;
            }),
            catchError((err) => {
                logger?.error(`Error fetching JSON translation: ${err}`);
                return of(null);
            }),
            tap(result => logger?.debug(`Schema for key ${key} is ${result}`)),
        );
    }
}
